export default __webpack_public_path__ + "static/media/pickuponly_deactive.558c2c45.svg";